import React from 'react'
import { textStyle } from '../Main/constants'
import { Container } from '@mui/material'

export default function ZasadySoukromiKurzy() {
    return (
        <Container maxWidth="md" sx={{ my: '160px', textAlign: 'left', pt: { xs: '0px', sm: '40px' } }}>
            <div style={{ textAlign: 'left', ...textStyle }}>

                <h1 style={{ textAlign: 'center', fontSize: '24px' }}>INFORMAČNÍ MEMORANDUM KE ZPRACOVÁNÍ OSOBNÍCH ÚDAJU</h1>
                <p style={{ textAlign: 'center' }}>
                    Zásady zpracování osobních údajů dětí a jejich zákonných zástupců
                    <br /><br />
                    Informační povinnost ve smyslu NAŘÍZENÍ EVROPSKÉHO PARLAMENTU A RADY (EU) 2016/679 ze dne 27. dubna 2016 (GDPR)
                </p>
                <br />

                <br /><br /><br /><u>1. Totožnost a kontaktní údaje správce</u><br /><br />
                Ing. Petr Helan<br /><br />
                Hello Kids Camp<br /><br />
                Veveří 2583/106, 616 00 Brno<br /><br />
                IČ: 72502215<br /><br />
                v zastoupení ředitelky a koordinátorky Mgr. Petry Kalašové<br /><br />
                Správce nejmenuje pověřence pro ochranu osobních údajů, protože k tomu nemá zákonnou
                povinnost.
                <br /><br /><br /><u>2. Účely zpracovaní, pro které jsou osobní údaje určeny a právní základ pro zpracovaní</u><br /><br />
                Subjekty údajů jsou děti účastnící se jazykových kurzů, jejich zákonní zástupci a případně osoby
                oprávněné k vyzvedávání dítěte.<br /><br />
                Účelem zpracování osobních údajů je zejména:<br /><br />
                • přijetí a evidence přihlášky do jazykových kurzů prostřednictvím on-line rezervace na
                webových stránkách <a href='https://hellokidscamp.cz/'>https://hellokidscamp.cz/</a>,<br /><br />
                • organizace a realizace jazykových kurzů,<br /><br />
                • vedení nezbytné komunikace se zákonnými zástupci,<br /><br />
                • zajištění bezpečnosti a ochrany zdraví účastníků,<br /><br />
                • sjednání a správa pojištění odpovědnosti,<br /><br />
                • plnění povinností vůči orgánům veřejné moci,<br /><br />
                • vedení účetnictví a související administrativy,<br /><br />
                • pořizování a zveřejňování fotografií a videozáznamů dítěte za účelem prezentace činnosti<br /><br />
                organizátora na webových stránkách, sociálních sítích a v propagačních materiálech,
                pokud byl udělen příslušný souhlas.<br /><br />
                Právním základem zpracování osobních údajů je zejména nezbytnost zpracování pro přijetí
                přihlášky, organizaci a realizaci jazykových kurzů, plnění právních povinností správce
                a ochranu oprávněných zájmů správce souvisejících s organizací kurzů.<br /><br />
                V případě fotografií a videozáznamů používaných pro marketingové a propagační účely je právním
                základem souhlas zákonného zástupce dítěte, který lze kdykoli odvolat.
                <br /><br /><br /><u>3. Kategorie zpracovávaných údajů, zdroje údajů a zabezpečení</u><br /><br />
                Správce zpracovává zejména tyto osobní údaje:<br /><br />
                • identifikační údaje dítěte a zákonného zástupce (jméno, příjmení, datum narození,
                adresa bydliště),<br /><br />
                • kontaktní údaje zákonného zástupce (telefon, e-mail, adresa),<br /><br />
                • platební a účetní údaje související s úhradou kurzovného (včetně variabilního symbolu),<br /><br />
                • údaje o komunikaci mezi organizátorem a zákonnými zástupci,<br /><br />
                • fotografie a videozáznamy dítěte, pokud byl udělen příslušný souhlas.<br /><br />
                Zdrojem osobních údajů jsou zejména zákonní zástupci dítěte, případně údaje vzniklé v průběhu
                komunikace a organizace jazykových kurzů.<br /><br />
                Osobní údaje jsou zabezpečeny přiměřenými technickými a organizačními opatřeními.<br /><br />
                Elektronické údaje jsou uchovávány v zabezpečených systémech s omezeným přístupem
                a ochranou heslem. Listinné dokumenty jsou uchovávány v uzamčených prostorách nebo
                uzamčených složkách s přístupem pouze oprávněným osobám. Přístup k osobním údajům mají
                pouze osoby, které je potřebují ke své práci při organizaci a realizaci jazykových kurzů.
                <br /><br /><br /><u>4. Doba, po kterou budou osobní údaje uloženy</u><br /><br />
                Přihlášky a související dokumentace účastníků jsou uchovávány po dobu 3 let od skončení
                tábora.<br /><br />
                Účetní a daňové doklady jsou uchovávány po dobu stanovenou příslušnými právními předpisy,
                zpravidla 5 až 10 let.<br /><br />
                Fotografie a videozáznamy budou uchovávány po dobu 3 let od jejich pořízení nebo do odvolání
                souhlasu.
                <br /><br /><br /><u>5. Příjemci údajů</u><br /><br />
                • Příjemci osobních údajů<br /><br />
                Osobní údaje mohou být zpřístupněny poskytovatelům účetních služeb, poskytovatelům IT služeb
                a správy webových stránek, pojišťovnám zajišťujícím pojištění účastníků a orgánům veřejné moci
                v případech stanovených právními předpisy.<br /><br />
                • Předávání osobních údajů do třetích zemí<br /><br />
                V souvislosti s využíváním některých elektronických služeb (např. cloudového úložiště fotografií)
                může docházet k předávání osobních údajů mimo Evropskou unii. Takové předávání probíhá
                pouze při splnění podmínek stanovených GDPR a za použití odpovídajících záruk ochrany
                osobních údajů.
                <br /><br /><br /><u>6. Poučení o právech subjektů údajů</u><br /><br />
                Subjekt údajů má právo požadovat od správce přístup k osobním údajům.<br /><br />
                Subjekt údajů má právo na opravu a výmaz osobních údajů.<br /><br />
                Subjekt údajů má právo žádat omezení zpracování a má právo vznést proti zpracování námitku.<br /><br />
                Subjekt údajů má rovněž právo na přenositelnost údajů.<br /><br />
                Subjekt údajů má v případě poskytnutí souhlasu se zpracováním osobních údajů právo souhlas
                kdykoliv odvolat, tím není dotčena zákonnost zpracování založená na souhlasu uděleném před
                jeho odvoláním.<br /><br />
                Subjekt údajů má právo podat stížnost u dozorového úřadu, kterým je Úřad pro ochranu
                osobních údajů se sídlem Pplk. Sochora 27, 170 00 Praha 7, www.uoou.cz.
                <br /><br /><br /><u>7. Upozornění, zda je poskytování osobních údajů zákonným či dobrovolným požadavkem a možné důsledky jejich neposkytnutí</u><br /><br />
                Poskytnutí osobních údajů v rozsahu nezbytném pro přihlášení dítěte do jazykové kurzy, jejich
                organizaci a zajištění bezpečnosti je nezbytné. Bez poskytnutí těchto údajů není možné dítě do
                jazykového kurzu přihlásit ani zajistit jeho účast.<br /><br />
                Poskytnutí souhlasu se zpracováním fotografií a videozáznamů pro marketingové a propagační
                účely je dobrovolné. Neudělení souhlasu nemá vliv na účast dítěte v jazykovém kurzu.
                <br /><br /><br /><u>8. Jak nás můžete kontaktovat</u><br /><br />
                S jakýmkoliv dotazem nebo požadavkem na shora uvedené, se na nás můžete obrátit na
                petra.kalasova@hellokidscamp.cz.
            </div>
        </Container>
    )
}
